import { render } from "./GroupTab.vue?vue&type=template&id=b1763480&scoped=true"
import script from "./GroupTab.vue?vue&type=script&lang=js"
export * from "./GroupTab.vue?vue&type=script&lang=js"

import "./GroupTab.vue?vue&type=style&index=0&id=b1763480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1763480"]])

export default __exports__